import '@sagi.io/globalthis';

export default class FBInstantGame {
	constructor() {
		this.isOnFacebook = typeof globalThis.FBInstant !== 'undefined';
		this.isNotOnFacebook = !this.isOnFacebook;

		//this.base64Image = FBInstantGameImage.getImage();
		this.onLoaded = function () { };

		this.onInvite = function () { };

		this.isInitialized = false;
	}

	async initialize() {
		if (!this.isOnFacebook) {
			console.log('FBInstant is not loaded : initialize()');
			return;
		}

		if (this.isInitialized) {
			console.log('FBInstant is already Initialized : initialize()');
			return;
		}

		globalThis.FBInstant.setLoadingProgress(70);
		await globalThis.FBInstant.initializeAsync();

		//skipping game loading and pushing forward with loading done  

		globalThis.FBInstant.setLoadingProgress(100);
		await globalThis.FBInstant.startGameAsync();

		this.isInitialized = true;
	}

	async subscribeBot() {
		if (!this.isInitialized) {
			return;
		}

		if (await globalThis.FBInstant.player.canSubscribeBotAsync()) {
			try {
				await globalThis.FBInstant.player.subscribeBotAsync();
				// Player is subscribed to the bot
			} catch (_err) {
				// Handle subscription failure
			}
		}
	}

	async getProfile() {
		if (!this.isOnFacebook) {
			console.log('FBInstant is SDK not loaded : loadProfileData()');
			return;
		}

		if (!this.isInitialized) {
			console.log('FBInstant is not Initialized : loadProfileData()');
			return;
		}

		console.log('FBInstant.loadProfileData()');
		// Retrieving context and player information can only be done once startGameAsync() resolves

		const playerName = globalThis.FBInstant.player.getName();
		let playerPic = globalThis.FBInstant.player.getPhoto();

		if (playerPic && playerPic.length > 1000) {
			playerPic = null;
		} //check for bad pic data.  It can come in as a string of 1,000+ characters

		const playerId = globalThis.FBInstant.player.getID();
		const locale = globalThis.FBInstant.getLocale();
		console.log('FBInstant.startGameAsync() - Done');

		const profileData = {
			name: playerName,
			pic: playerPic,
			id: playerId,
			locale: locale,
		};

		return profileData;
	}

	async getInvite() {
		if (!this.isOnFacebook) {
			console.log('FBInstant is SDK not loaded : loadEntryPoint()');
			return;
		}

		if (!this.isInitialized) {
			console.log('FBInstant is not Initialized : loadEntryPoint()');
			return;
		}

		console.log('FBInstant.loadEntryPoint()');

		const entryPointData = globalThis.FBInstant.getEntryPointData();
		console.log('FBInstant.getEntryPointData()', entryPointData);

		let inviteData = null;

		//check for invite
		if (entryPointData && entryPointData.room) {
			inviteData = {
				room: entryPointData.room,
				message: entryPointData.message,
				server: entryPointData.server || '',
			};

		}

		return inviteData;
	}

	async loadData() {
		if (!this.isOnFacebook) {
			console.log('FBInstant is SDK not loaded : loadData()');
			return;
		}

		if (!this.isInitialized) {
			// Retrieving context and player information can only be done once startGameAsync() resolves
			console.log('FBInstant is not Initialized : loadData()');
			return;
		}

		console.log('FBInstant.loadData()');

		let userData = null;

		try {
			const data = await globalThis.FBInstant.player.getDataAsync(['userdata']);
			userData = data?.['userdata'] ?? null;

			if (typeof userData !== 'object') {
				userData = null;
			}
		} catch (err) {
			console.log('FBInstant.getDataAsync() - caught exception', err);
		}

		return userData;
	}

	async saveData(userdata, forceSave) {
		if (!this.isInitialized) {
			return;
		}

		if (!userdata) {
			return;
		}

		if (!userdata.facebookId && !forceSave) {
			return;
		}

		try {
			await globalThis.FBInstant.player.setDataAsync({
				userdata: userdata,
			});
			console.log('FBInstant data saved');

			if (forceSave) {
				console.log('FBInstant flushDataAsync');
				await globalThis.FBInstant.player.flushDataAsync();
			}
		} catch (ex) {
			console.log('FBInstant.player.setDataAsync() - catch - ' + ex);
			console.log(ex);
		}
	}

	loadProfileDataTest() {
		const playerName = 'Jimmy';
		let playerPic = 'https://scontent-sjc3-1.xx.fbcdn.net/v/t1.0-1/11139003_10152870794711964_3739797864585429440_n.jpg?_nc_cat=0&oh=2fff2747f02b3c56054c5e192199bff6&oe=5B6FEEF1';
		const playerId = '1472723356169778';
		playerPic = encodeURIComponent(playerPic);
		const data = {
			playerName: playerName,
			playerPic: playerPic,
			playerId: playerId,
			entryPointData: null,
		};
		return data;
	}

	invitePlayer(playerId, roomName) {
		if (!this.isInitialized) {
			console.log('FBInstant is not loaded');
			return;
		}

		//needs to be a string
		playerId = playerId + '';

		if (!roomName) {
			roomName = Math.floor(Math.random() * Math.floor(1000000000));
		}

		const message = 'You have been challenged to a game!';

		//ask to share
		(async () => {
			try {
				await globalThis.FBInstant.context.createAsync(playerId);
				console.log('FBInstant.context.choose() ' + globalThis.FBInstant.context.getID());
				// 1234567890
				//roomName = FBInstant.context.getID();
				await this.updateAsyncRoom(message, roomName);
			} catch (ex) {
				if (ex.code == 'SAME_CONTEXT') {
					//roomName = FBInstant.context.getID();
					await this.updateAsyncRoom(message, roomName);
					//window.location.href = "#/Game/Online/" + roomName;
				}

				console.log('FBInstant.context.choose() ' + JSON.stringify(ex));
				// 1234567890
			}
		})();

		return true;
	}

	inviteSend(userdata, roomName) {
		if (!this.isInitialized) {
			console.log('FBInstant is not loaded');
			return;
		}

		let message = 'You have been challenged to a game!';
		const contextId = globalThis.FBInstant.context.getID();

		if (userdata && userdata.name) {
			message = userdata.name + ' has challenged you to a game!';
		}

		if (!roomName && userdata && userdata.facebookId) {
			roomName = userdata.facebookId;
		}

		if (!roomName && contextId) {
			roomName = contextId;
		}

		if (!roomName) {
			roomName = Math.floor(Math.random() * Math.floor(1000000000));
		}

		//ask to share
		(async () => {
			try {
				await globalThis.FBInstant.context.chooseAsync({
					maxSize: 2,
				});
				console.log('FBInstant.context.choose() ' + globalThis.FBInstant.context.getID());
				// 1234567890
				//roomName = FBInstant.context.getID();
				this.updateAsyncRoom(message, roomName);

			} catch (ex) {
				if (ex.code == 'SAME_CONTEXT') {
					console.log('FBInstant.context.choose() ' + globalThis.FBInstant.context.getID());
					//roomName = FBInstant.context.getID();
					this.updateAsyncRoom(message, roomName);
					//window.location.href = "#/Game/Online/" + roomName;
				}

				console.log('FBInstant.context.choose() ' + JSON.stringify(ex));
				// 1234567890
			}
		})();
	}

	async updateAsyncRoom(message, roomName) {
		if (!this.isInitialized) {
			console.log('FBInstant is not loaded');
			return;
		}

		try {
			await globalThis.FBInstant.updateAsync({
				action: 'CUSTOM',
				cta: 'Play',
				//image: this.base64Image,
				text: {
					default: message,
					localizations: {
						en_US: message,
						pt_BR: message,
					},
				},
				template: 'room_created',
				data: {
					message: message,
					room: roomName,
				},
				strategy: 'IMMEDIATE',
				notification: 'PUSH',
			});

			console.log('Message was sent successfully');
			console.log('room created and entered: ' + roomName);

			//get new game room
			this.onInvite?.({
				message: message,
				room: roomName,
			});
		} catch (ex) {
			console.log('Facebook.challenge Error: ' + ex);
			console.log(ex);
			console.log(JSON.stringify(ex));

		}
	}

	getConnectedPlayersAsync() {
		if (!this.isInitialized) {
			return Promise.reject('FBInstant is not loaded');
		}

		try {
			return globalThis.FBInstant.player.getConnectedPlayersAsync();
		} catch (ex) { //bug in IE11 with facebook script crashing before promise is created
			console.log('FBInstant.getConnectedPlayersAsync() - catch - ' + ex);
		}
	}

	shareAsync(base64Data, text) {
		if (!this.isInitialized) {
			return Promise.resolve(false);
		}

		return globalThis.FBInstant.shareAsync({
			image: base64Data,
			text: text,
			data: {},
		});
	}

	canCreateShortcut() {
		if (!this.isInitialized) {
			return Promise.resolve(false);
		}

		return globalThis.FBInstant.canCreateShortcutAsync();
	}

	async createShortcut() {
		if (!this.isInitialized) {
			return;
		}

		console.log('canCreateShortcutAsync');

		if (await this.canCreateShortcut()) {

			console.log('canCreateShortcut = true');

			try {
				await globalThis.FBInstant.createShortcutAsync();
				// Shortcut created
				console.log('canCreateShortcutAsync - Shortcut created');
			} catch (err) {
				// Shortcut not created
				console.log('canCreateShortcutAsync - Shortcut not created');
			}
		}
	}

	switchGameAsync(id) {
		if (!this.isInitialized) {
			return Promise.resolve(false);
		}

		return globalThis.FBInstant.switchGameAsync(id);
	}
}
